// extracted by mini-css-extract-plugin
module.exports = {"ldsRoller":"Loading_ldsRoller__3WsvR"};